import {Validation} from "../../src/validation";

document.addEventListener("DOMContentLoaded", () => {
    const form = document.querySelector("#login_form");
    const verifyEmailButton = document.querySelector("#email_verification");

    const validator = Validation.getDefaultValidator(form);

    form.addEventListener("submit", (e) => {
        Validation.validateFormWithReCaptcha(e, validator);
    });

    verifyEmailButton?.addEventListener("click", e => {
        e.preventDefault();
        Validation.disableButton(verifyEmailButton);

        verifyEmailButton.form.submit();
    });
});


